<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 lg12 mb-3>
        <v-expansion-panel popout>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">What is GROW WITH STOCKS ?</h3>
            <v-card>
              <v-card-text>
                <p> Grow with Stocks is a stock research and advisory firm with a mission to give retail investor the necessary tools, guidance and confidence so that they can be in the best position to perform lot better than the so called fund managers and create wealth over long term. The majority of people in India are unaware and have misconceptions about stock market and see investing in stocks as intimidating.</p>
                <p> We intend to change this dogma and enable more and more people to take advantage of this huge opportunity offered by Indian market over the next 10 to 20 years. </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question"> Why do I have to take the paid subscription to receive wealth creating stocks?</h3>
            <v-card>
              <v-card-text>
                <p> GROW WITH STOCKS is not a tips provider company. Free tips are readily available in the market. However,they are more damaging to your portfolio than beneficial.</p>
                <p> We put in a lot of effort and resources in researching tons of stocks and shortlist few unconventional and high potential stocks that can give you the returns in the north of 150% to 300%. </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">How many stocks will I get if I take an annual membership?</h3>
            <v-card>
              <v-card-text>
                <p> 12 stocks for annual subscription, 24 stocks for 2 years plan and 36 stocks for 3 years special plan. You may also receive couple of bonus stocks free of cost.</p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">What will I receive in free sign up?</h3>
            <v-card>
              <v-card-text>
                <p> One free sample report and weekly newsletter regarding stock market, macro economic trends/factors etc.</p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">Do I get a refund?</h3>
            <v-card>
              <v-card-text>
                <p>
                  We strive to provide you with best of the best stocks. However, we do not offer refunds.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">Why am I unable to access the monthly stocks archive?</h3>
            <v-card>
              <v-card-text>
                <p>
                  Full and unrestricted access to our stocks archive is a feature of our paid membership.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">What is the average holding period of each stock?
            </h3>
            <v-card>
              <v-card-text>
                <p>
                  The average holding period is usually 2-3 years, but we have seen in the past when few of our stocks have achieved its target within 6-8 months.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">How much money I should invest monthly?
            </h3>
            <v-card>
              <v-card-text>
                <p>
                  Well, every investor is unique when it comes to his financial capacity, we don’t follow one size fits all strategy. You can expect to have a clear capital allocation strategy after having a 10 minutes discussion call with our experts. </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">Do you provide timely updates including buy, sell(exit) call?
            </h3>
            <v-card>
              <v-card-text>
                <p>
                  Yes, not only we provide timely buy and sell alerts. We also provide you updates on when to average an existing share.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question">What type of stocks you recommend in your subscription?
            </h3>
            <v-card>
              <v-card-text>
                <p>
                  As long as it’s a high quality growth stock, we are least bothered with which sector it belongs to or whether it’s a mid or a large cap company.
                </p>
                <p>
                  Our priority in evaluating a stock includes –
                </p>
                <ul>
                  <li>
                    Company’s fundamentals
                  </li>
                  <li>
                    Management competency and integrity
                  </li>
                  <li>
                    High returns potential
                  </li>
                  <li>
                    Fair valuation
                  </li>
                  <li>
                    And many other variables.
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <h3 slot="header" class="faq-question"> "I want to invest, but I don't want to lose money."
            </h3>
            <v-card>
              <v-card-text>
                <p>
                  Well, you're not alone.We totally understand your fear. You're investing your hard-earned money to grow your investment returns.
                </p>
                <p>
                  The truth is that loss happen in a couple of stocks out of a dozen stocks. Even the world's best investors pick the occasional dud. But that’s a part of the game.
                </p>
                <p>
                  The successful investors understand that if you buy and hold for the long term, it's possible one of your investments could go down by 50 - 60%. But the rest of the stocks can give you many, many times more than you could ever lose.
                </p>
                <p>
                  With our highly curated quality stocks, your winners will outperform the losers in your portfolio. It’s the net returns which makes the difference in the end. That strategy has helped hundreds and hundreds of our investors build wealth and beat the market.
                </p>
                <p>
                  In case, you still have some doubts, you can clarify those while having a 10 minutes’ strategy discussion call with our experts.
                </p>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    name: 'FaqChild',
    mounted() {
      this.$nextTick(() => this.wireAriaExpanded());
    },
    beforeDestroy() {
      if (this._faqObservers) {
        this._faqObservers.forEach(o => o.disconnect());
      }
      if (this._faqKeyHandlers) {
        this._faqKeyHandlers.forEach(({ container, onKeydown }) =>
          container.removeEventListener('keydown', onKeydown));
      }
    },
    methods: {
      // WCAG 4.1.2 — announce expanded/collapsed state on each FAQ question.
      //
      // Vuetify 1.5.x renders v-expansion-panel-content as:
      //   <li class="v-expansion-panel__container" tabindex="0" aria-expanded="…">
      //     <div class="v-expansion-panel__header">…slot=header…</div>
      //     <div class="v-expansion-panel__body">…</div>
      //   </li>
      //
      // The <li> is the focusable element AND Vuetify already manages
      // aria-expanded on it. But Vuetify does NOT add a role, so NVDA sees a
      // generic list item with aria-expanded — and the state is never spoken.
      // Adding role="button" makes the widget a button, so NVDA announces
      // "Question text, button, collapsed" on focus.
      //
      // role="button" goes on the Vuetify container <li> because that is the
      // focusable element AND the node where the aria-expanded Vuetify already
      // binds actually gets announced. We deliberately do NOT add an aria-label:
      // the answer panel is a CHILD of this <li>, and button has "presentational
      // children", so the answer text is only reachable through the button's
      // computed name when expanded. Overriding the name with aria-label would
      // risk hiding the answer from screen readers. Proper long-term fix is a
      // real button/region structure (Vuetify 2+ or a custom accordion).
      wireAriaExpanded() {
        const questions = this.$el.querySelectorAll('.faq-question');
        this._faqObservers = [];
        this._faqKeyHandlers = [];
        questions.forEach(q => {
          const container = q.closest('.v-expansion-panel__container');
          if (!container) return;
          container.setAttribute('role', 'button');
          // A button must also activate on Space (WCAG 2.1.1). Vuetify only
          // wires Enter on this <li>, so without this Space just scrolls the
          // page. Guard with e.target === container so a Space typed inside the
          // (focusable) panel body is never hijacked into toggling the panel.
          const onKeydown = e => {
            if (e.target !== container) return;
            if (e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32) {
              e.preventDefault();
              const header = container.querySelector('.v-expansion-panel__header');
              if (header) header.click();
            }
          };
          container.addEventListener('keydown', onKeydown);
          this._faqKeyHandlers.push({ container, onKeydown });
          const sync = () => {
            const isOpen = container.classList.contains('v-expansion-panel__container--active');
            container.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          };
          sync();
          const observer = new MutationObserver(sync);
          observer.observe(container, { attributes: true, attributeFilter: ['class'] });
          this._faqObservers.push(observer);
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .card__text {
    li {
      margin-left: 20px;
    }
  }
  .faq-question {
    font-weight: 600;
    font-size: 1.1em;
    padding: 9px 0;
    margin: 0;
    line-height: 1.4;
    color: #1a1a1a;
  }
  .expansion-panel__header > h3 {
    font-weight: 600;
    font-size: 1.1em;
    padding: 9px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/FaqChild.vue